import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../actions/reportAction';
import * as orderAction from './../../../../../actions/orderAction';
import ReportCashFlow from './ReportCashFlow';

const mapStateToProps = state => {
    return {
        reportState: state.reportReducer,
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSaleReport: (filters) => dispatch(reportAction.getSaleReport(filters)),
        exportExcel: filters => dispatch(orderAction.exportExcel(filters)),
        getCashFlowReport: (filters) => dispatch(reportAction.getCashFlowReport(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ReportCashFlow));
